export function Autumn({ color = '#5B5B5B' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="44"
      viewBox="0 0 42 44"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.7783 33.5137L31.1239 35.2527C31.5708 35.3278 31.9283 34.8918 31.7672 34.4684L30.7698 31.846C30.6786 31.6063 30.7482 31.3467 30.9471 31.1849L40.8256 23.1447C41.1447 22.885 41.1051 22.3907 40.749 22.1851L38.8979 21.1163C38.6518 20.9742 38.5443 20.6833 38.639 20.4153L40.4805 15.2034C40.6376 14.7587 40.2336 14.3219 39.778 14.444L35.0275 15.7168C34.7684 15.7863 34.5041 15.6769 34.37 15.4446L32.9739 13.0262C32.7809 12.6921 32.327 12.6323 32.0542 12.9052L28.5408 16.4186C28.1417 16.8176 27.4635 16.4737 27.5497 15.916L29.0206 6.39822C29.0958 5.91239 28.5764 5.55697 28.1507 5.80275L25.1292 7.54724C24.8326 7.71848 24.458 7.6027 24.3098 7.29395L21.2083 0.834132C20.9969 0.393782 20.3658 0.393881 20.1544 0.834132L17.0529 7.29395C16.9047 7.6027 16.5303 7.71848 16.2337 7.54724L13.212 5.80275C12.7863 5.55687 12.267 5.91239 12.3421 6.39822L13.813 15.9159C13.8992 16.4737 13.2209 16.8176 12.8219 16.4186L9.30849 12.9052C9.03572 12.6323 8.58183 12.6921 8.38884 13.0262L6.99275 15.4446C6.85849 15.6769 6.59432 15.7863 6.33519 15.7168L1.58468 14.444C1.1291 14.3219 0.725034 14.7587 0.882232 15.2034L2.72371 20.4153C2.81843 20.6833 2.71106 20.9742 2.46478 21.1163L0.613711 22.1851C0.257496 22.3907 0.218049 22.8849 0.53709 23.1447L10.4156 31.1849C10.6145 31.3467 10.6841 31.6063 10.593 31.846L9.5955 34.4684C9.43445 34.8918 9.79195 35.3278 10.2388 35.2527L20.5845 33.5137C20.6518 33.5024 20.7109 33.5024 20.7783 33.5137Z"
        fill={color}
      />
      <path
        d="M19.7246 43.3613V33.4971H21.6381V43.3613H19.7246Z"
        fill={color}
      />
    </svg>
  )
}
